<template>
  <div class="alumno-upload-container">
    <h3 class="title">Actualiza Casa masivo</h3>
    <div class="upload-section">
      <label class="file-label">
        <span>Seleccionar archivo Excel (.xlsx, .xls)</span>
        <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" class="file-input" />
      </label>
    </div>
    <div v-if="excelData.length" class="progress-section">
      <div class="progress-info">
        <span>Progreso: {{ processedCount }} / {{ excelData.length }}</span>
        <span>{{ currentStatus }}</span>
      </div>
      <progress :value="processedCount" :max="excelData.length"></progress>
      <button
        class="action-button"
        @click="procesarActualizarCasas"
        :disabled="isProcessing || !excelData.length"
      >
        {{ isProcessing ? 'Procesando...' : 'Actualizar Casas' }}
      </button>
      <div v-if="resultados.length" class="results-section">
        <h4>Resultados del Procesamiento</h4>
        <div class="results-table">
          <div class="table-header">
            <span>RUT</span>
            <span>Curso</span>
            <span>Curso Casa</span>
            <span>Email</span>
            <span>Estado</span>
          </div>
          <div v-for="(resultado, index) in resultados" :key="index" class="table-row">
            <span>{{ resultado.rut }}</span>
            <span>{{ resultado.curso }}</span>
            <span>{{ resultado.curso_casa }}</span>
            <span>{{ resultado.email }}</span>
            <span :class="resultado.estado === 'Éxito' ? 'status-success' : 'status-error'">
              {{ resultado.estado }}
            </span>
          </div>
        </div>
      </div>
      <div v-if="debugInfo.length" class="debug-section">
        <h4>Información de Depuración</h4>
        <ul>
          <li v-for="(log, index) in debugInfo" :key="index">{{ log }}</li>
        </ul>
      </div>
      <div v-if="errores.length" class="error-actions">
        <button class="error-button" @click="descargarErrores">
          Descargar Errores ({{ errores.length }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import UsuarioService from '@/services/UsuarioService';

export default {
  data() {
    return {
      excelData: [],
      isProcessing: false,
      processedCount: 0,
      currentStatus: '',
      errores: [],
      resultados: [],
      debugInfo: [],
      usuarioId: 1,
      colegios: {
        "NO APLICA": { id_colegio: 0, direccion_calle: "", direccion_numero: 0 },
        "MINEDUC DEMO": { id_colegio: 1, direccion_calle: "EJERCITO", direccion_numero: 557 },
        "COLEGIO ACONCAGUA": { id_colegio: 2, direccion_calle: "Camino Troncal Antiguo", direccion_numero: 1940 },
        "COLEGIO SAN NICOLÁS VILLA ALEMANA": { id_colegio: 3, direccion_calle: "Santa Sarah", direccion_numero: 1720 },
        "COLEGIO SAN NICOLÁS CANAL CHACAO": { id_colegio: 4, direccion_calle: "Los Lunes", direccion_numero: 373 },
        "COLEGIO SAN NICOLÁS EL OLIVAR": { id_colegio: 5, direccion_calle: "Tamarugal", direccion_numero: 575 }
      },
      regiones: [
        { Id: 6, Glosa: 'Valparaíso' }
      ],
      comunas: [
        { Id: 45, Glosa: 'Valparaíso' },
      ]
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        // Filtrar filas vacías o irrelevantes
        this.excelData = jsonData.slice(1).filter(row => {
          // Verificar que la fila tenga al menos RUT o Email, Curso, y Curso_casa
          const rut = row[3] ? row[3].toString().trim() : '';
          const email = row[8] ? row[8].toString().trim() : '';
          const curso = row[1] ? row[1].toString().trim() : '';
          const cursoCasa = row[2] ? row[2].toString().trim() : '';
          return (rut || email) && curso && cursoCasa;
        });
        console.log('excelData:', this.excelData);
        this.processedCount = 0;
        this.errores = [];
        this.resultados = [];
        this.debugInfo = [];
        this.currentStatus = '';
      };
      reader.readAsArrayBuffer(file);
    },
    getIdComunaPorColegio(colegioGlosa) {
      const comunaPorColegio = {
        "NO APLICA": "Villa Alemana",
        "MINEDUC DEMO": "Villa Alemana",
        "COLEGIO ACONCAGUA": "Quilpué",
        "COLEGIO SAN NICOLÁS VILLA ALEMANA": "Villa Alemana",
        "COLEGIO SAN NICOLÁS CANAL CHACAO": "Quilpué",
        "COLEGIO SAN NICOLÁS EL OLIVAR": "Viña del Mar"
      };
      const comunaGlosa = comunaPorColegio[colegioGlosa] || "Villa Alemana";
      const comuna = this.comunas.find(c => c.Glosa === comunaGlosa);
      return comuna ? comuna.Id : 52;
    },
    async procesarActualizarCasas() {
      if (this.isProcessing || !this.excelData.length) return;
      this.isProcessing = true;
      this.processedCount = 0;
      this.errores = [];
      this.resultados = [];
      this.debugInfo = [];
      try {
        for (const [index, rowData] of this.excelData.entries()) {
          console.log('Procesando fila:', rowData);
          const rut = rowData[3] ? rowData[3].toString().trim() : '';
          const cursoCasa = rowData[2] ? rowData[2].toString().trim() : '';
          const curso = rowData[1] ? rowData[1].toString().trim() : '';
          const email = rowData[8] ? rowData[8].toString().trim() : '';

          // Validación
          if (!rut && !email) {
            this.errores.push([...rowData, `Fila ${index + 2}: Se requiere RUT o Email`]);
            this.resultados.push({ rut, curso, curso_casa: cursoCasa, email, estado: 'Error: RUT o Email requerido' });
            continue;
          }
          if (!cursoCasa) {
            this.errores.push([...rowData, `Fila ${index + 2}: Curso_casa es requerido`]);
            this.resultados.push({ rut, curso, curso_casa: cursoCasa, email, estado: 'Error: Curso_casa requerido' });
            continue;
          }
          if (!curso) {
            this.errores.push([...rowData, `Fila ${index + 2}: Curso es requerido`]);
            this.resultados.push({ rut, curso, curso_casa: cursoCasa, email, estado: 'Error: Curso requerido' });
            continue;
          }

          const payload = {
            IdentificadorRut: rut,
            CursoCasa: cursoCasa,
            Curso: curso,
            Email: email,
            IdUsuario: this.usuarioId
          };

          try {
            this.currentStatus = `Procesando fila ${index + 2} de ${this.excelData.length}...`;
            const response = await UsuarioService.actualizarCursoCasaMasivo([payload]);
            console.log('Respuesta del backend:', response);
            this.processedCount++;
            this.debugInfo = [...this.debugInfo, ...response.data.DebugInfo];
            this.resultados.push({ rut, curso, curso_casa: cursoCasa, email, estado: 'Éxito' });
          } catch (error) {
            const errorMsg = error.response?.data?.Mensaje || error.message || 'Error desconocido';
            this.errores.push([...rowData, `Fila ${index + 2}: ${errorMsg}`]);
            if (error.response?.data?.DebugInfo) {
              this.debugInfo = [...this.debugInfo, ...error.response.data.DebugInfo];
            }
            this.resultados.push({ rut, curso, curso_casa: cursoCasa, email, estado: `Error: ${errorMsg}` });
          }
        }
        this.currentStatus = `Proceso completado. ${this.excelData.length - this.errores.length} éxitos, ${this.errores.length} errores.`;
      } catch (error) {
        console.error("Error inesperado en actualización de casas:", error);
        this.currentStatus = "Error inesperado en el proceso de actualización de casas";
        this.errores.push(['', '', '', '', error.message || 'Error desconocido']);
        this.debugInfo.push(`Error inesperado en el proceso: ${error.message}`);
      } finally {
        this.isProcessing = false;
      }
    },
    descargarErrores() {
      if (!this.errores.length) return;
      const headers = ["Colegio", "Curso", "Curso Casa", "RUT", "Paterno", "Materno", "Nombre Alumno", "Sexo", "Correo", "RUT Apoderado", "Paterno Apoderado", "Materno Apoderado", "Nombre Apoderado", "Correo Apoderado", "Sexo Apoderado", "Error"];
      const data = [headers, ...this.errores];
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Errores");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Errores_Actualizar_Curso_Casa.xlsx";
      link.click();
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.alumno-upload-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
}
.title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}
.upload-section {
  margin-bottom: 30px;
  text-align: center;
}
.file-label {
  display: inline-block;
  padding: 12px 24px;
  background-color: #4285f4;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-weight: bold;
}
.file-label:hover {
  background-color: #3367d6;
}
.file-input {
  display: none;
}
.progress-section {
  margin-top: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
  color: #555;
}
progress {
  width: 100%;
  height: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}
progress::-webkit-progress-bar {
  background-color: #e9ecef;
  border-radius: 5px;
}
progress::-webkit-progress-value {
  background-color: #28a745;
  border-radius: 5px;
}
.action-button {
  display: inline-block;
  width: 31%;
  margin: 0 1%;
  padding: 12px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}
.action-button:hover {
  background-color: #218838;
}
.action-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}
.error-actions {
  margin-top: 20px;
}
.error-button {
  display: block;
  width: 100%;
  padding: 10px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.error-button:hover {
  background-color: #c82333;
}
.results-section {
  margin-top: 20px;
}
.results-table {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}
.table-header,
.table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 2fr 1fr;
  padding: 10px;
}
.table-header {
  background-color: #e9ecef;
  font-weight: bold;
}
.table-row:nth-child(even) {
  background-color: #f8f9fa;
}
.status-success {
  color: #28a745;
  font-weight: bold;
}
.status-error {
  color: #dc3545;
  font-weight: bold;
}
.debug-section {
  margin-top: 20px;
  max-height: 300px;
  overflow-y: auto;
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
}
.debug-section ul {
  list-style: none;
  padding: 0;
}
.debug-section li {
  font-size: 12px;
  color: #333;
  margin-bottom: 5px;
}
</style>